import { OrganizationInvitations } from "@/features/organization-invitations";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/invitations")({
  component: Invitations
});

function Invitations() {
  return <OrganizationInvitations />;
}
